import React from "react";

const SidebarItems = ({ children }) => (
  <div className={["sidebar-item"].join(" ")}>{children}</div>
);

export default SidebarItems;
